import Board from './BoardPage';

export default Board;
